import { RouterModule, Routes } from "@angular/router";
import { NgModule } from "@angular/core";
import { InfoLayoutComponent } from "./info.layout";
import { InfoComponent } from "./info.component";

export const routes: Routes = [
    {
        path: "",
        component: InfoLayoutComponent,
        children: [
            {
                path: "",
                component: InfoComponent,
            },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class InfoRoutingModule {}
